// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__34Hhc","title":"ClientInsurance_title__14TqJ","itemText":"ClientInsurance_itemText__2xCDM"};